import { ICON_TYPES } from './iconTypes';

export default {
	palette: {
		name: 'th-large',
		type: ICON_TYPES.fontAwesome,
		text: 'Color',
	},
	eraser: {
		name: 'eraser',
		type: ICON_TYPES.fontAwesome,
		text: 'Erase',
	},
	brush: {
		name: 'paint-brush',
		type: ICON_TYPES.fontAwesome,
		text: 'Draw',
	},
	resize: {
		name: 'arrows-alt',
		type: ICON_TYPES.fontAwesome,
		text: 'Size',
	},
	undo: {
		name: 'undo',
		type: ICON_TYPES.fontAwesome,
		text: 'Undo',
	},
	canvasBack: {
		name: 'angle-left',
		type: ICON_TYPES.fontAwesome,
		text: 'Back',
	},
	canvasSave: {
		name: 'check-circle',
		type: ICON_TYPES.fontAwesome,
		text: 'Save',
	},
	eye: {
		name: 'eye',
		type: ICON_TYPES.fontAwesome,
		text: 'View',
	},
	eyeOff: {
		name: 'eye-slash',
		type: ICON_TYPES.fontAwesome,
		text: 'Hide',
	},
};